import React from 'react';
import { Breadcrumb } from 'flowbite-react';
import type { IconType } from 'react-icons';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	name: string;
	items: {
		label: string;
		icon?: IconType;
		link?: string;
	}[];
}

const Breadcrumbs = ({ name, items, ...props }: Props) => {
	const navigate = useNavigate();

	return (
		<Breadcrumb aria-label={name} className={classNames(props.className)}>
			{items.map((item, i) => (
				<Breadcrumb.Item
					key={i}
					icon={item.icon}
					onClick={() => {
						if (item.link) navigate(item.link);
					}}
				>
					<p
						className={classNames('max-w-md text-[#1F3343] dark:!text-[#EBEBF0] font-[500] text-ellipsis truncate', {
							'cursor-pointer': item.link,
						})}
					>
						{item.label}
					</p>
				</Breadcrumb.Item>
			))}
		</Breadcrumb>
	);
};

export default Breadcrumbs;
